<template src="./LegalMentions.html"/>

<style lang="scss" scoped src="./LegalMentions.scss"/>

<script>

import {
  SfBreadcrumbs,
  SfNotification
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";


export default {
  name: 'LegalMentions',
  transition: 'fade',
  components: {
    OrkLoader,
    SfNotification,
    SfBreadcrumbs
  },
  data() {
    return {
      content: '',
      loading: false,
      error: null,
      locale: this.$i18n.locale,
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: this.$i18n.t('Legal mentions'),
        }
      ]
    };
  },
  created() {
    this.getLegalMentions()
  },
  methods: {
    getLegalMentions() {
      this.loading = true
      Api.platform.getLegalMentions().then((data) => {
        this.content = data;
      }).catch((e) => {
        this.error = e.status;
      }).finally(
          this.loading = false
      )
    }
  }
};
</script>
